<script setup lang="ts">
/**
 * PrivacyView — Art. 13 GDPR notice (INC-138, ADR-073, SPEC §5.4/§5.5).
 * Prerendered as a static route (`vite.config.ts` `includedRoutes`). Text
 * lives in i18n (`privacy.sections`, walked with `tm`/`rt`); controller
 * identity comes from the `VITE_LEGAL_*` build env (`src/data/app.ts`, §3).
 */
import { useI18n } from 'vue-i18n'
import { LEGAL_CONTROLLER, PRIVACY_UPDATED } from '@/data/app'

const { t, tm, rt } = useI18n()
const { name, location, contactEmail, authority } = LEGAL_CONTROLLER

// `SSR` is true only while vite-ssg prerenders this route, never in a client
// build or in dev/tests — so a missing controller env fails `npm run build`
// instead of shipping a legal notice with blank/broken placeholders (D6).
if (import.meta.env.SSR && (!name || !location || !contactEmail)) {
  throw new Error('VITE_LEGAL_NAME/LOCATION/CONTACT missing: refusing to prerender /privacy')
}

const params = { controller: name, location, contact: contactEmail, authority }
</script>

<template>
  <article class="mx-auto w-full max-w-2xl px-6 py-12">
    <h1 class="text-2xl font-bold text-fg-primary">{{ t('privacy.title') }}</h1>
    <p class="mt-1 text-sm text-fg-secondary">
      {{ t('privacy.updated', { date: PRIVACY_UPDATED }) }}
    </p>

    <section v-for="(s, i) in tm('privacy.sections')" :key="i" class="mt-8">
      <h2 class="text-lg font-semibold text-fg-primary">{{ rt(s.title) }}</h2>
      <p v-for="(p, j) in s.paragraphs" :key="j" class="mt-2 text-fg-secondary">
        {{ rt(p, params) }}
      </p>
    </section>

    <RouterLink
      to="/"
      class="mt-10 inline-block text-sm text-fg-secondary underline hover:text-accent-text"
    >
      {{ t('waitlistAction.home') }}
    </RouterLink>
  </article>
</template>
